export enum ChangeDebtor {
  CHANGE_DEBTOR_START = "CHANGE_DEBTOR_START",
  CHANGE_DEBTOR_SUCCESS = "CHANGE_DEBTOR_SUCCESS",
  CHANGE_DEBTOR_FAIL = "CHANGE_DEBTOR_FAIL",

  CHANGE_DEBTOR_DRAWER = "CHANGE_DEBTOR_DRAWER",
}
